import axios from "axios";
// import {router} from "../router";
import store from "../store/store";
import { authenticate } from "./api";



// const baseURL = "http://localhost:3000";
const baseURL = "https://pc.advancingecoag.org";

const PC = axios.create({
  baseURL
});

PC.interceptors.request.use(config => {
  config.headers.common["Authorization"] = localStorage.AEAApiToken;
  return config;
});

PC.interceptors.response.use(async config => {
  if (!config.data.success && config.data.message === "authentication failed") {
    let res = await authenticate.getThirdPartyToken("AEA");

    if (!res.data.success || !res.data.tokens || !res.data.tokens.token) {
      store.dispatch("notify", {
        message: "You need to grant access to AEA data, click <a target='_blank' href='https://login.crophealthlabs.net/oauth/authorize/aea'>here.</a>",
        confirm: true,
        variant: "warn"
      });
    }

    localStorage.AEAApiToken = res.data.tokens.token;
  }
  return config;
});

export const program = {
  search: {
    string(string) {
      return PC.get(`/api/programs/search/${string}`);
    }
  },

  program: {
    get(id) {
      return PC.get(`/api/programs/${id}`);
    },
    recents() {
      return PC.get("/api/programs/recents");
    }
  },

  application: {
    createUpdate(data) {
      return PC.post("/api/applications", data);
    },
    single(catId) {
      return PC.get("/api/applications", {params: {catId}});
    },
    byTab(tabIds) {
      return PC.get("/api/applications/tab", {params: {tabIds}});
    }
  },

  category: {
    row(data) {
      return PC.post("/api/categories/row", data);
    },
    byProgram(programId) {
      return PC.get("/api/categories/byProgram", {params: {programId}});
    }
  }
};
